module.exports = __webpack_public_path__ + "static/media/CalendarEvent3.89257e90.jpg";